module.exports = __webpack_public_path__ + "img/cloud.337ea654.svg";